import { useState } from "react";

// https://www.linkedin.com/pulse/implementing-undo-redo-functionality-react-apps-components-alex-lomia/
export default function useUndoRedo<T>(initialState: T) {
  const [past, setPast] = useState<T[]>([]);
  const [present, setPresent] = useState(initialState);
  const [future, setFuture] = useState<T[]>([]);

  const undo = () => {
    if (past.length === 0) return;

    const newPast = [...past];
    const newPresent = newPast.pop()!;

    setPast(newPast);
    setFuture([present, ...future]);
    setPresent(newPresent);
  };

  const redo = () => {
    if (future.length === 0) return;

    const newFuture = [...future];
    const newPresent = newFuture.shift()!;

    setPast([...past, present]);
    setFuture(newFuture);
    setPresent(newPresent);
  };

  const updatePresent = (newState: T) => {
    setPast([...past, present]);
    setPresent(newState);
    setFuture([]);
  };

  const reset = () => {
    setPast([]);
    setPresent(past[0]);
    setFuture([]);
  };

  return {
    state: present,
    undo,
    redo,
    updatePresent,
    hasUndo: past.length > 0,
    hasRedo: future.length > 0,
    reset,
  };
}
